
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 133057","xmlns":"http://www.w3.org/2000/svg","width":"31","height":"31","viewBox":"0 0 31 31"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"chevron_right"}},[_c('path',{attrs:{"data-name":"Union 1","d":"M18.572 14.305l-6.475-6.757a1.363 1.363 0 00-.955-.395 1.321 1.321 0 00-.943.395 1.369 1.369 0 00-.018 1.885l.006.011 5.574 5.8-5.58 5.823a1.362 1.362 0 00.018 1.882l.013.023a1.423 1.423 0 00.948.361 1.3 1.3 0 00.938-.384h.012l6.462-6.751a1.347 1.347 0 000-1.894z","fill":"#717b8c"}})])])
          )
        }
      }
    